import { type FileRetention, RetentionResourceType, type RetentionPolicy, RetentionRuleType, type TTLRetentionRule } from '../../../../models/RetentionPolicy'

export const DAILY_THRESHOLD_HOURS = 24
export const WEEKLY_THRESHOLD_HOURS = 24 * 7

const UNIT_TO_HOURS: Record<string, number> = { hour: 1, day: 24, week: 24 * 7 }

const ttlHoursOf = (rule: TTLRetentionRule): number => (rule.config.value ?? 0) * (UNIT_TO_HOURS[rule.config.unit] ?? 0)

const isEligibleResource = (policy: RetentionPolicy): boolean =>
  policy.resource.type === RetentionResourceType.SESSION ||
  (policy.resource.type === RetentionResourceType.FILE && (policy.resource as FileRetention).config?.kind === 'transcription')

export interface DataRetentionWarningEmailAvailability {
  isWeeklyFrequencyAvailable: boolean
  hasShortEligiblePolicy: boolean
}

export const getDataRetentionWarningEmailAvailability = (policies: RetentionPolicy[] | undefined): DataRetentionWarningEmailAvailability => {
  const ttlHours = (policies ?? [])
    .filter((policy) => policy.rule.type === RetentionRuleType.TTL && isEligibleResource(policy))
    .map((policy) => ttlHoursOf(policy.rule as TTLRetentionRule))

  const eligibleTTLHours = ttlHours.filter((hours) => hours >= DAILY_THRESHOLD_HOURS)
  const isAvailable = eligibleTTLHours.length > 0
  return {
    isWeeklyFrequencyAvailable: isAvailable && eligibleTTLHours.every((hours) => hours >= WEEKLY_THRESHOLD_HOURS),
    hasShortEligiblePolicy: ttlHours.some((hours) => hours < DAILY_THRESHOLD_HOURS),
  }
}
